var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtstation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "as",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vAs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64,124a60,60,0,1,1,60-58.86A59.88,59.88,0,0,1,64,124ZM55.8,28.67l38.63,66c.29-.41.51-.66.68-.94,2-3.34,3.89-6.7,5.87-10a7.47,7.47,0,0,0,0-8.11L94.85,65.13,76,32.76a7.62,7.62,0,0,0-7.17-4.1c-1.5,0-3,0-4.51,0ZM82,94.71c-.32-.59-.49-.93-.67-1.25-2.47-4.23-5-8.44-7.39-12.69a2.13,2.13,0,0,0-2.16-1.23q-22.13.06-44.23,0c-.46,0-.92,0-1.53.08,2.21,3.78,4.33,7.41,6.47,11a7.64,7.64,0,0,0,7.07,4H82ZM66.82,68.77C61,58.88,55.34,49.16,49.53,39.26L32.25,68.77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtstation);
export default __webpack_public_path__ + "static/media/artstation.157dc8ac562aadfbc725b9e8056e82cd.svg";
export { ForwardRef as ReactComponent };